const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const splitDate = (text = "") => {
  const [day = "", month = "", year = ""] = String(text).split("/");
  return {
    day: day.replace(/\D/g, "").slice(0, 2).padStart(2, "0"),
    month: month.replace(/\D/g, "").slice(0, 2).padStart(2, "0"),
    year: year.replace(/\D/g, "").slice(0, 4),
  };
};

const fmtQty = (value) => {
  const num = Number(value || 0);
  if (!Number.isFinite(num)) return "";
  if (Math.abs(num - Math.trunc(num)) < 0.000001) return `${Math.trunc(num)}`;
  return num.toFixed(3).replace(/\.0+$/, "").replace(/(\.\d*?)0+$/, "$1");
};

export const getPrintTemplate = ({ headerInfo, committeeMembers, rows, totals }) => {
  const documentDate = splitDate(headerInfo.documentDate);
  const referenceDate = splitDate(headerInfo.referenceDate);

  const committeeRows = (committeeMembers || [])
    .map(
      (member) => `
      <div style="margin-bottom:4px;">
        + Ông/Bà ${escapeHtml(member.fullName || "....................")} Chức vụ ${escapeHtml(
    member.position || "................"
  )} Đại diện ${escapeHtml(member.representative || "................")} ${escapeHtml(
    member.role || ""
  )}
      </div>
    `
    )
    .join("");

  const tableRows = (rows || [])
    .map(
      (row, index) => `
      <tr>
        <td class="center">${index + 1}</td>
        <td>${escapeHtml(row.itemName || "")}</td>
        <td class="center">${escapeHtml(row.itemCode || "")}</td>
        <td class="center">${escapeHtml(row.inspectionMethod || "")}</td>
        <td class="center">${escapeHtml(row.unit || "")}</td>
        <td class="right">${fmtQty(row.quantityByDocument)}</td>
        <td class="right">${fmtQty(row.quantityCorrect)}</td>
        <td class="right">${fmtQty(row.quantityIncorrect)}</td>
        <td>${escapeHtml(row.note || "")}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Biên Bản Kiểm Nghiệm</title>
      <style>
        @media print { @page { margin: 10mm 8mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", serif; font-size: 15px; color:#000; margin: 0; padding: 12px; }
        .page { width: 100%; margin: 0 auto; }
        .header { display:flex; justify-content:space-between; align-items:flex-start; }
        .left { line-height:1.4; }
        .right { text-align:center; line-height:1.35; }
        .title { text-align:center; margin-top:12px; font-size:29px; font-weight:700; text-transform:uppercase; }
        .subtitle { text-align:center; margin-top:3px; font-size:21px; }
        .date-line { text-align:center; margin-top:8px; font-style:italic; }
        .doc-no { text-align:right; margin-top:8px; }
        .content { margin-top:10px; line-height:1.5; }
        table { width:100%; border-collapse:collapse; margin-top:8px; font-size:14px; }
        th, td { border:1px solid #000; padding:4px; vertical-align:middle; }
        th { text-align:center; font-weight:700; }
        .center { text-align:center; }
        .right { text-align:right; }
        .sign-wrap { margin-top:18px; display:flex; justify-content:space-between; text-align:center; }
        .sign-col { width:42%; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="page">
        <div class="header">
          <div class="left">
            <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit || "")}</div>
            <div><b>Bộ phận:</b> ${escapeHtml(headerInfo.department || "")}</div>
          </div>
          <div class="right">
            <div><b>Mẫu số: 03 - VT</b></div>
            <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
            <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
          </div>
        </div>

        <div class="title">BIÊN BẢN KIỂM NGHIỆM</div>
        <div class="subtitle">Vật tư, công cụ, sản phẩm, hàng hóa</div>
        <div class="date-line">Ngày ${documentDate.day || "..."} tháng ${documentDate.month || "..."} năm ${documentDate.year || "...."}</div>
        <div class="doc-no">Số: ${escapeHtml(headerInfo.documentNumber || "")}</div>

        <div class="content">
          <div>- Căn cứ ${escapeHtml(headerInfo.referenceName || "")} số ${escapeHtml(
    headerInfo.referenceNumber || ""
  )} ngày ${referenceDate.day || "..."} tháng ${referenceDate.month || "..."} năm ${
    referenceDate.year || "...."
  } của ${escapeHtml(headerInfo.referenceIssuer || "")}</div>
          <div style="margin-top:4px;"><b>Ban kiểm nghiệm gồm:</b></div>
          ${committeeRows}
          <div><b>Đã kiểm nghiệm các loại:</b></div>

          <table>
            <thead>
              <tr>
                <th rowspan="2" style="width:5%">Số TT</th>
                <th rowspan="2" style="width:28%">Tên nhãn hiệu, quy cách vật tư, công cụ, sản phẩm, hàng hóa</th>
                <th rowspan="2" style="width:8%">Mã số</th>
                <th rowspan="2" style="width:10%">Phương thức kiểm nghiệm</th>
                <th rowspan="2" style="width:8%">Đơn vị tính</th>
                <th rowspan="2" style="width:10%">Số lượng theo chứng từ</th>
                <th colspan="2" style="width:18%">Kết quả kiểm nghiệm</th>
                <th rowspan="2" style="width:13%">Ghi chú</th>
              </tr>
              <tr>
                <th>Số lượng đúng quy cách, phẩm chất</th>
                <th>Số lượng không đúng quy cách, phẩm chất</th>
              </tr>
              <tr>
                <th>A</th><th>B</th><th>C</th><th>D</th><th>E</th><th>1</th><th>2</th><th>3</th><th>F</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows}
              <tr>
                <td colspan="5" class="center"><b>Cộng</b></td>
                <td class="right"><b>${fmtQty(totals.quantityByDocument)}</b></td>
                <td class="right"><b>${fmtQty(totals.quantityCorrect)}</b></td>
                <td class="right"><b>${fmtQty(totals.quantityIncorrect)}</b></td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <div style="margin-top:8px;"><b>Ý kiến của Ban kiểm nghiệm:</b> ${escapeHtml(
            headerInfo.committeeOpinion || ""
          )}</div>

          <div class="sign-wrap">
            <div class="sign-col">
              <div><b>Đại diện bộ phận có nhu cầu kiểm nghiệm</b></div>
              <div><i>(Ký, họ tên)</i></div>
            </div>
            <div class="sign-col">
              <div><b>Đại diện bộ phận cung cấp dịch vụ kiểm nghiệm</b></div>
              <div><i>(Ký, họ tên)</i></div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
